import React from 'react';

import { LinkButton } from '@eika/button';
import { useIsDesktop } from '@eika/hooks/src/useViewType';
import { ListPanel, ListPanelWrapper } from '@eika/link-panel';

import useText from '@/hooks/use-text';

import { useConfigLink } from '@domain/app';
import { useTranslations } from '@domain/translations';
import { CreditCard, CreditCardAccount } from '@generated-types';
import { getKredittbankenUrl, goToUrl } from '@utils/url-utils';

import { getKbCreditCardDetails } from './getKbCreditCardDetails';

import './CardDetailsList.scss';

type DesktopCardDetailsProps = {
    card: CreditCard;
    account: CreditCardAccount;
};

export const DesktopCardDetails = ({ card, account }: DesktopCardDetailsProps) => {
    const text = useText();
    const isDesktop = useIsDesktop();
    const configUrl = useConfigLink('kredittbankenChangeDueDate');

    const detailItem = getKbCreditCardDetails(card, text, account);
    const { cardAdmin } = useTranslations();
    const changeDueDate = () => {
        const url = getKredittbankenUrl(configUrl.url, card, account);
        goToUrl(url);
    };

    return (
        <ListPanelWrapper
            hideBackground
            titleContent={isDesktop && <h3>{cardAdmin.details}</h3>}
            className={!isDesktop ? 'card-details-list-wrapper__mobile' : 'card-details-list-wrapper__desktop'}
        >
            {detailItem.map((item) => (
                <ListPanel
                    title={item.description}
                    textOne={item.value}
                    key={item.value.toString()}
                    className={!isDesktop ? 'card-details-list__mobile' : undefined}
                />
            ))}
            <ListPanel
                title={text.overviewDetailsInvoiceDate}
                textOne={`${account.billingSummary.paymentDueDay}${text.overviewDetailsInvoiceDueDate}`}
            />
            {!isDesktop && (
                <LinkButton className="card-details-list__change-due-date" onClick={changeDueDate}>
                    {text.cardLinkChangeDueDate}
                </LinkButton>
            )}
        </ListPanelWrapper>
    );
};
